<div class="tw-flex tw-items-center tw-justify-between">
    @if (!headerTemplate()) {
        <div class="tw-flex-column tw-flex">
            @if (title()) {
                <h2 mat-dialog-title>
                    {{ title() }}
                </h2>
            }
            @if (subtitle()) {
                <h3>{{ subtitle() }}</h3>
            }
        </div>
    }

    @if (headerTemplate()) {
        <div>
            <ng-container *ngTemplateOutlet="headerTemplate()"></ng-container>
        </div>
    }

    @if (showCloseButton()) {
        <button aria-label="Schließen"
            mat-icon-button
            mat-dialog-close>
            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
        </button>
    }
</div>

<mat-dialog-content>
    @if (bodyTemplate()) {
        <ng-container *ngTemplateOutlet="bodyTemplate()"></ng-container>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    @if (footerTemplate()) {
        <ng-container *ngTemplateOutlet="footerTemplate()"></ng-container>
    }

    @if (showCloseButton()) {
        <button
            mat-raised-button
            mat-dialog-close
            (click)="close()">
            Schließen
        </button>
    }
</mat-dialog-actions>
